// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1znAn","search":"Settings_search__2Dun4","filter":"Settings_filter__2_oXi"};